import { render, staticRenderFns } from "./aside-cta-youtube.component.vue?vue&type=template&id=4726994a&"
import script from "./aside-cta-youtube.component.vue?vue&type=script&lang=ts&"
export * from "./aside-cta-youtube.component.vue?vue&type=script&lang=ts&"
import style0 from "./aside-cta-youtube.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "aside-cta-youtube.component.vue"
export default component.exports